export default "__VITE_ASSET__DZz8lbSc__"